import React, { useCallback } from "react";
import {
  Card,
  DeleteIcon,
  FormField,
  IconButton,
  InlineAlert,
  Pane,
  TextInput,
} from "evergreen-ui";
import AutocompleteFormField from "../AutocompleteFormField";

const insertIntoSelected = (selected, insert) => {
  const insertInSelected = selected.find(
    (category) => category["category_id"] === insert["category_id"]
  );
  if (insertInSelected) {
    return selected.map((category) =>
      category["category_id"] === insert["category_id"] ? insert : category
    );
  } else {
    return [...selected, insert];
  }
};

const AccountingInputSplit = ({
  amount = 0,
  hasAmount,
  categories,
  isDeletable,
  id,
  account_categories: selected,
  onSplitChange,
  ...props
}) => {
  const elementToString = useCallback(
    (element) => (element ? element["element_name"] : ""),
    []
  );

  const handleAmountChange = useCallback(
    (event) => {
      const updatedSplit = {};
      updatedSplit["amount"] = event.target.value;
      updatedSplit["id"] = id;
      updatedSplit["account_categories"] = selected;
      onSplitChange(updatedSplit);
    },
    [id, onSplitChange, selected]
  );

  const handleCategoryChange = useCallback(
    (categoryID) => (selectedElement) => {
      const updatedSplit = {};
      updatedSplit["amount"] = amount;
      updatedSplit["id"] = id;
      const newSelectedCategory = {
        category_id: categoryID,
        value_id: selectedElement?.["element_id"],
      };
      updatedSplit["account_categories"] = insertIntoSelected(
        selected,
        newSelectedCategory
      );
      onSplitChange(updatedSplit);
    },
    [amount, id, onSplitChange, selected]
  );

  const handleDelete = useCallback(() => {
    onSplitChange();
  }, [onSplitChange]);

  return (
    <Card display="flex" elevation={1} {...props}>
      <Pane display="flex" flex="1 100%" flexWrap="wrap">
        {categories && categories.length ? (
          categories.map((category) => {
            const selectedCategory = selected.find(
              (selectedInvoiceCategory) =>
                selectedInvoiceCategory["category_id"] ===
                category["category_id"]
            );
            const currentElement = category["elements"].find(
              (element) =>
                element["element_id"] === selectedCategory?.["value_id"]
            );
            if (!category["category_active"] && !currentElement) {
              return null;
            }
            return (
              <AutocompleteFormField
                disabled={!category["category_active"]}
                flex="0 45%"
                items={category["elements"]}
                itemToString={elementToString}
                key={`AutocompleteFormField_${category["category_id"]}`}
                label={category["category_name"]}
                margin={8}
                onChange={handleCategoryChange(category["category_id"])}
                placeholder={
                  category["category_active"]
                    ? `Select ${category["category_name"]}`
                    : "(Category is not active)"
                }
                value={currentElement}
              />
            );
          })
        ) : (
          <InlineAlert flex="0 0 50%" intent="warning" margin={8}>
            Categories catalog couldn't be retrieved.
          </InlineAlert>
        )}
        {hasAmount ? (
          <FormField flex="0 40%" label="Amount ($)" margin={8}>
            <TextInput
              onChange={handleAmountChange}
              value={amount}
              width="100%"
            />
          </FormField>
        ) : null}
      </Pane>
      <Pane flex="0 0 auto" padding={8}>
        {isDeletable ? (
          <IconButton
            appearance="minimal"
            icon={DeleteIcon}
            onClick={handleDelete}
          />
        ) : null}
      </Pane>
    </Card>
  );
};

export default AccountingInputSplit;
